export const CopyIconV2 = (props) => (
  <svg fill="none" height={24} viewBox="0 0 24 24" width={24} xmlns="http://www.w3.org/2000/svg" {...props}>
    <rect
      height={13}
      rx={2}
      stroke={props.color ? props.color : "#055a17"}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      width={13}
      x={9}
      y={9}
    />
    <path
      d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1"
      stroke={props.color ? props.color : "#055a17"}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
    />
  </svg>
);
